// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-preview {
    background-color: var(--primary-color-lightest);
}
.link-preview img {
    width: 100%;
}
.link-preview .link-preview__site {
    margin: 0;
    padding: 1em 20px 0 20px;
    color: var(--primary-color-dark);
    font-size: 12px;
    text-align: left;
}
.link-preview h2.link-preview__title {
    margin: 0;
    padding: 0.5em 20px 0 20px;
    color: var(--main-text-color);
    font-size: 16px;
    text-align: left;
    font-weight: 500;
}
.link-preview .link-preview__description {
    padding: 0.5em 20px 1em 20px;
    color: var(--primary-color-dark);
    text-align: left;
    font-size: 14px;
}

.link-preview iframe {
    aspect-ratio: 16 / 9;
    width: 100%;
    border: none;
}
`, "",{"version":3,"sources":["webpack://./client/components/links/view/LinkPreview.css"],"names":[],"mappings":"AAAA;IACI,+CAA+C;AACnD;AACA;IACI,WAAW;AACf;AACA;IACI,SAAS;IACT,wBAAwB;IACxB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,0BAA0B;IAC1B,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB","sourcesContent":[".link-preview {\n    background-color: var(--primary-color-lightest);\n}\n.link-preview img {\n    width: 100%;\n}\n.link-preview .link-preview__site {\n    margin: 0;\n    padding: 1em 20px 0 20px;\n    color: var(--primary-color-dark);\n    font-size: 12px;\n    text-align: left;\n}\n.link-preview h2.link-preview__title {\n    margin: 0;\n    padding: 0.5em 20px 0 20px;\n    color: var(--main-text-color);\n    font-size: 16px;\n    text-align: left;\n    font-weight: 500;\n}\n.link-preview .link-preview__description {\n    padding: 0.5em 20px 1em 20px;\n    color: var(--primary-color-dark);\n    text-align: left;\n    font-size: 14px;\n}\n\n.link-preview iframe {\n    aspect-ratio: 16 / 9;\n    width: 100%;\n    border: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
